var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivityimg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "url(#paint0_linear_852_1226)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "url(#paint1_linear_852_1226)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_852_1226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0402 22.5H31.8131C31.3747 22.5 30.9543 22.6756 30.6443 22.988C30.3343 23.3005 30.1602 23.7243 30.1602 24.1662V31.25L45.0402 40L52.4802 43.165L59.9202 40V31.25L45.0402 22.5Z",
    fill: "#C0C0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1602 31.25H45.0402V40H30.1602V31.25Z",
    fill: "#A6A6C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2671 22.5H45.04V31.25H59.92V24.1662C59.92 23.7243 59.7459 23.3005 59.4359 22.988C59.1259 22.6756 58.7055 22.5 58.2671 22.5Z",
    fill: "#D9D9E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0402 40H30.1602V55.8337C30.1602 56.2757 30.3343 56.6995 30.6443 57.012C30.9543 57.3244 31.3747 57.5 31.8131 57.5H58.2672C58.7056 57.5 59.126 57.3244 59.436 57.012C59.746 56.6995 59.9202 56.2757 59.9202 55.8337V48.75L45.0402 40Z",
    fill: "#8181B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.04 40H59.92V48.75H45.04V40Z",
    fill: "#A6A6C9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M40.9072 28.75H30.1602V52.5H40.9072C41.3452 52.4987 41.7649 52.3227 42.0746 52.0105C42.3843 51.6983 42.5588 51.2753 42.5602 50.8337V30.4163C42.5588 29.9747 42.3843 29.5517 42.0746 29.2395C41.7649 28.9273 41.3452 28.7513 40.9072 28.75Z",
    fill: "#08080D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.6672 30H30.1602V53.75H39.6672C40.1052 53.7487 40.5249 53.5727 40.8346 53.2605C41.1443 52.9483 41.3188 52.5253 41.3202 52.0837V31.6663C41.3188 31.2247 41.1443 30.8017 40.8346 30.4895C40.5249 30.1773 40.1052 30.0013 39.6672 30Z",
    fill: "#08080D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M39.6672 30H30.1602V51.25H39.6672C40.1052 51.2487 40.5249 51.0727 40.8346 50.7605C41.1443 50.4483 41.3188 50.0253 41.3202 49.5837V31.6663C41.3188 31.2247 41.1443 30.8017 40.8346 30.4895C40.5249 30.1773 40.1052 30.0013 39.6672 30Z",
    fill: "#08080D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.4272 30H30.1602V51.25H38.4272C38.8652 51.2487 39.2849 51.0727 39.5946 50.7605C39.9043 50.4483 40.0788 50.0253 40.0802 49.5837V31.6663C40.0788 31.2247 39.9043 30.8017 39.5946 30.4895C39.2849 30.1773 38.8652 30.0013 38.4272 30Z",
    fill: "#08080D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8932 30H38.4273C38.8657 30 39.2861 30.1756 39.5961 30.488C39.9061 30.8005 40.0802 31.2243 40.0802 31.6663V48.3337C40.0802 48.7757 39.9061 49.1995 39.5961 49.512C39.2861 49.8244 38.8657 50 38.4273 50H21.8932C21.4548 50 21.0343 49.8244 20.7244 49.512C20.4144 49.1995 20.2402 48.7757 20.2402 48.3337V31.6663C20.2402 31.2243 20.4144 30.8005 20.7244 30.488C21.0343 30.1756 21.4548 30 21.8932 30Z",
    fill: "#8181B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6211 46.25L28.6337 39.9825L24.9584 33.75H27.9158L29.9221 37.7338C30.1064 38.1113 30.2333 38.3929 30.3028 38.5787H30.3288C30.4611 38.2771 30.5995 37.9838 30.7442 37.6988L32.8882 33.75H35.6025L31.8329 39.9475L35.698 46.25H32.8088L30.4913 41.875C30.3821 41.6886 30.2895 41.4929 30.2147 41.29H30.18C30.1124 41.4884 30.0225 41.6784 29.9122 41.8563L27.5277 46.25H24.6211Z",
    fill: "#F2F2F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_852_1226",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05050F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8DB9",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_852_1226",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8DB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27273F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_852_1226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivityimg6);
export default __webpack_public_path__ + "static/media/productivityimg6.82e3fdd6adb71887499ebf986b4f6ecb.svg";
export { ForwardRef as ReactComponent };